import { css, keyframes } from "@emotion/core";
import { Keyframes } from "@emotion/serialize";

import { OVERLAY_ZINDEX } from "shared/styles/base";

type translateStates = [string | number, string | number, string | number];

// TODO - Move to styles animation helpers
const getTranslate3DKeyframes = (
    [startX, startY, startZ]: translateStates,
    [endX, endY, endZ]: translateStates
) => keyframes`
    from {
        transform: translate3D(${startX}, ${startY}, ${startZ});
    }

    to {
        transform: translate3D(${endX}, ${endY}, ${endZ});
    }
`;

const getAnimationCss = (animation: Keyframes) => css`
    animation: ${animation} 0.2s ease-in;
`;

const getSlideKeyframes = (initialState: translateStates) => [
    getTranslate3DKeyframes(initialState, [0, 0, 0]),
    getTranslate3DKeyframes([0, 0, 0], initialState),
];

const [slideBottomIn, slideBottomOut] = getSlideKeyframes([0, "100%", 0]);
const [slideTopIn, slideTopOut] = getSlideKeyframes([0, "-100%", 0]);
const [slideLeftIn, slideLeftOut] = getSlideKeyframes(["-100%", 0, 0]);
const [slideRightIn, slideRightOut] = getSlideKeyframes(["100%", 0, 0]);

export const sheetCss = css`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${OVERLAY_ZINDEX + 1};
    position: fixed;
`;

export const sheetTopIn = getAnimationCss(slideTopIn);
export const sheetTopOut = getAnimationCss(slideTopOut);
export const sheetBottomIn = getAnimationCss(slideBottomIn);
export const sheetBottomOut = getAnimationCss(slideBottomOut);
export const sheetLeftIn = getAnimationCss(slideLeftIn);
export const sheetLeftOut = getAnimationCss(slideLeftOut);
export const sheetRightIn = getAnimationCss(slideRightIn);
export const sheetRightOut = getAnimationCss(slideRightOut);
